export default __webpack_public_path__ + "static/media/factory-future-leadership.3ffc920e.svg";